function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserHeadIdea({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_x5F_head_x5F_idea",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 32",
    style: {
      enableBackground: "new 0 0 26 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "user_x5F_head_x5F_idea_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M17,32h-2v-7h4c1.103,0,2-0.897,2-2v-5h2.946L20.052,6.316c-0.222-0.563-0.777-1.188-0.971-1.378 C17.182,3.04,14.671,2,12,2C6.486,2,2,6.486,2,12c0,2.606,0.786,4.739,1.547,6.802C4.262,20.738,5,22.74,5,25v7H3v-7 c0-1.903-0.646-3.653-1.329-5.507C0.888,17.37,0,14.964,0,12C0,5.383,5.383,0,12,0c3.205,0,6.218,1.248,8.485,3.514 c0.092,0.088,1.004,0.993,1.446,2.121L26,17.838V18c0,1.103-0.897,2-2,2h-1v3c0,2.206-1.794,4-4,4h-2V32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD5C3F"
    },
    points: "13.414,22 10.586,22 9,20.414 9,16 11,16 11,19.586 11.414,20 12.586,20 13,19.586 13,16  15,16 15,20.414  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M12,18c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S14.757,18,12,18z M12,10 c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S13.654,10,12,10z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.343,
    y: 6.343,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -3.3346 6.6349)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 4,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 16.656,
    y: 6.343,
    transform: "matrix(0.7072 -0.707 0.707 0.7072 -0.0221 14.6329)",
    style: {
      fill: "#FD5C3F"
    },
    width: 2.001,
    height: 2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 12,
    style: {
      fill: "#FD5C3F"
    },
    width: 2,
    height: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHeadIdea);
export default __webpack_public_path__ + "static/media/user_head_idea.16a403f90d5b5c584443f7bc3867f45f.svg";
export { ForwardRef as ReactComponent };